import { Injectable } from '@angular/core';
import { Photographer, PhotographerFilters } from '../models/new/photographer';
import { UtilitiesService } from 'src/app/services/utilities.service';
import moment from 'moment';
import { Brand } from '../models/new/brand.model';
import { Status } from '../models/new/status';
import { Company } from 'src/app/shared/libs/models/context.model';

@Injectable({
	providedIn: 'root'
})
export class PhotographerMapper {
	constructor(private utils: UtilitiesService) {}

	toPhotographer(photographer: any) {
		return new Photographer({
			id: photographer.personId,
			firstName: photographer.firstName,
			lastName: photographer.lastName,
			fullName: photographer.fullName,
			createdAt: photographer.createdAt ? new Date(photographer.createdAt) : undefined,
			contractStartDate: photographer.contractStartDate ? new Date(photographer.contractStartDate) : undefined,
			contractEndDate: photographer.contractEndDate ? new Date(photographer.contractEndDate) : undefined,
			email: photographer.email,
			phoneNumber: photographer.phoneNumber,
			totalRevenue: photographer.totalRevenue,
			brands: photographer.brands?.map((b: any) => new Brand({ id: b.brandId, name: b.brandName })),
			status: photographer.statusId ? new Status({ id: photographer.statusId, name: photographer.statusName }) : undefined,
			company: photographer.companyId ? new Company({ Id: photographer.companyId }) : undefined
		});
	}

	toWhereClause(filters: PhotographerFilters): any {
		return {
			brands: filters.brands?.length ? { some: { brandId: { in: filters.brands.map((b) => b.id) } } } : undefined,
			fullName: filters.textSearch ? { contains: filters.textSearch } : undefined,
			// Il DTO espone contractStartDate/contractEndDate: filtro sui contratti la cui data di inizio ricade nel range selezionato
			contractStartDate: filters.contractDate
				? {
						gte: moment(filters.contractDate.from).startOf('day').toISOString(),
						lte: moment(filters.contractDate.to).endOf('day').toISOString()
					}
				: undefined,

			statusId: filters.statuses?.length ? { in: filters.statuses.map((s) => s.id) } : undefined
		};
	}

	filtersToUrl(filters: PhotographerFilters): any {
		return {
			brands: filters.brands?.map((b) => b.id),
			textSearch: filters.textSearch || undefined,
			contractDateFrom: filters.contractDate ? moment(filters.contractDate.from).format('YYYY-MM-DD') : undefined,
			contractDateTo: filters.contractDate ? moment(filters.contractDate.to).format('YYYY-MM-DD') : undefined,
			statuses: filters.statuses?.map((s) => s.id),

			page: filters.page || 1,
			size: filters.size || 20
		};
	}

	urlToFilters(url: any) {
		return new PhotographerFilters({
			brands: url.brands ? (Array.isArray(url.brands) ? url.brands.map((id: any) => new Brand({ id: Number(id) })) : [new Brand({ id: Number(url.brands) })]) : undefined,
			contractDate: url.contractDateFrom && url.contractDateTo ? { from: new Date(url.contractDateFrom), to: new Date(url.contractDateTo) } : undefined,
			statuses: url.statuses ? (Array.isArray(url.statuses) ? url.statuses.map((id: any) => new Status({ id: Number(id) })) : [new Status({ id: Number(url.statuses) })]) : undefined,
			textSearch: url.textSearch || undefined,

			page: url.page ? Number(url.page) : 1,
			size: url.size ? Number(url.size) : 20
		});
	}

	toPhotographerStatus(node: any) {
		return {
			id: node.id,
			name: node.name
		};
	}
}
